import React from "react";
import "./About.css";
import { personalInfo } from "../data/portfolioData";
import { HiDownload, HiServer, HiDatabase, HiChartBar, HiChip } from "react-icons/hi";

function About() {
  const pillars = [
    {
      icon: <HiServer size={24} />,
      title: "Microservices & Distributed Systems",
      desc: "Architecting resilient, independently deployable services in Golang (Gin) and Python (Flask/Django) that communicate over event-driven pipelines and REST APIs.",
    },
    {
      icon: <HiDatabase size={24} />,
      title: "Data Stores & Messaging",
      desc: "Handling high-volume distributed data models with Cassandra, ScyllaDB, and Redis, paired with real-time NATS and Kafka stream ingestion.",
    },
    {
      icon: <HiChartBar size={24} />,
      title: "Deep Observability",
      desc: "Authoring custom Prometheus exporters across SQL, NoSQL, and SNMP targets to ensure complete telemetry, alert correlation, and rapid incident detection.",
    },
    {
      icon: <HiChip size={24} />,
      title: "Applied AI Workflows",
      desc: "Bridging core backend infrastructure with LLM-assisted operations via LangChain and RAG architectures over internal ITSM documentation.",
    },
  ];

  return (
    <section id="about" className="about-section section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Background</span>
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">
            Focusing on scalable backend architectures, distributed event pipelines, and production reliability.
          </p>
        </div>

        <div className="about-grid">
          {/* Narrative Card */}
          <div className="about-narrative-card">
            <h3 className="about-card-title">Engineering Focus</h3>
            <p className="about-paragraph">{personalInfo.summary}</p>
            <p className="about-paragraph">
              My engineering philosophy revolves around building decoupled, observable, and failure-tolerant
              systems. Having built mission-critical services for enterprise IT operations automation and AIOps,
              I prioritize clean contracts, predictable concurrency models, and low-latency pipeline throughput.
            </p>
            <div className="about-cta-row">
              <a
                href={personalInfo.links.resume}
                download="Prasanna_Kumar_Resume.pdf"
                className="btn btn-primary"
                aria-label="Download resume"
              >
                <HiDownload size={18} />
                <span>Download Resume</span>
              </a>
            </div>
          </div>

          {/* Core Architectural Pillars */}
          <div className="about-pillars-grid">
            {pillars.map((pillar, idx) => (
              <div key={idx} className="pillar-card">
                <div className="pillar-icon-box">{pillar.icon}</div>
                <h4 className="pillar-title">{pillar.title}</h4>
                <p className="pillar-desc">{pillar.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
